module.exports = __webpack_public_path__ + "static/media/STAF_bokmål_sentrert logo_neg(hvit).b191276c.svg";